import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import '@mdi/font/css/materialdesignicons.css'
import de from 'vuetify/lib/locale/de'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
	options: {
		customProperties: true
	}
})

export default new Vuetify({
	treeShake: true,
	theme: {
		themes: {
			light: {
				primary: '#303841',
				secondary: '#19D3DA',
				secondaryTransparent: 'rgba(25,211,218,0.18)',
				accent: '#FF5722',
				error: '#b71c1c',
				info: '#2196F3',
				success: '#4CAF50',
				warning: '#FFC107',
				circle: '#FF5722'
			}
		}
	},
	lang: {
		locales: { de },
		current: 'de'
	}
})
